import { render, staticRenderFns } from "./Ingredient.vue?vue&type=template&id=9440b480&scoped=true&"
import script from "./Ingredient.vue?vue&type=script&lang=js&"
export * from "./Ingredient.vue?vue&type=script&lang=js&"
import style0 from "./Ingredient.vue?vue&type=style&index=0&id=9440b480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9440b480",
  null
  
)

export default component.exports